// Order ステータス（shared_back の Order.Status と同期させること）
// domain/index.ts で `export * as Order` されるため、利用側からは Order.Status で参照する。
export const Status = {
    Authorized: "authorized", // 旧スキーム互換: 予約時オーソリ済（履歴のみ）
    InBilling: "inBilling", // 旧スキーム互換（履歴のみ）
    Done: "done", // 精算完了
    Canceled: "canceled", // キャンセル
    Failed: "failed", // 決済失敗
    ReOrder: "reOrder", // 旧スキーム互換（履歴のみ）
    PendingAuthentication: "pendingAuthentication", // 3DS 認証待ち
};
